/**CORE LIBRARIES IMPORT */
import React from "react";

const Testimonial=()=>{
    return(
        <>

        </>
    )
}

export default Testimonial;